import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { InternalNotesCardComponent, InternalNotesComponent } from '@shared/internal-notes/components';
import { CustomTooltipModule } from '@shared/tooltip/custom-tooltip.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { DirectivesModule } from '@shared/directives/directives.module';

@NgModule({
  declarations: [InternalNotesComponent, InternalNotesCardComponent],
  imports: [CommonModule, FormWrapperModule, TranslateModule, CustomTooltipModule, PipesSharedModule, NgxMaskModule, DirectivesModule],
  exports: [InternalNotesComponent, InternalNotesCardComponent],
})
export class InternalNotesModule {}
